export const ctaTranslations = {
  ctaTitle: {
    fr: "Rejoignez First Tuesday : le rendez-vous mensuel des professionnels algériens",
    en: "Join First Tuesday: the monthly meeting of Algerian professionals"
  },
  ctaSubtitle: {
    fr: "Chaque premier mardi du mois à Alger, connectez-vous avec des professionnels expérimentés et bâtissez l'avenir ensemble",
    en: "Every first Tuesday of the month in Algiers, connect with experienced professionals and build the future together"
  },
  ctaJoin: {
    fr: "Rejoindre First Tuesday",
    en: "Join First Tuesday"
  },
  ctaServices: {
    fr: "Voir le programme",
    en: "See the programme"
  },
};